import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import Select from 'Components/Atoms/Select/Select';

export default function RHFSelect({ name, options, ...other }) {
    const { control, clearErrors } = useFormContext();

    const normalizedOptions = options?.map((option) => ({
        ...option,
        value: 'value' in option ? option.value : option.id,
    }));

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => {
                useEffect(() => {
                    if (field.value && error) {
                        clearErrors(name);
                    }
                }, [name, field.value, clearErrors]);

                return <Select {...field} options={normalizedOptions} error={error?.message} {...other} />;
            }}
        />
    );
}

RHFSelect.propTypes = {
    name: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            label: PropTypes.node,
        }),
    ),
};
